import type { UserProfile } from '../../../auth';

type UserIdentity = {
  username?: string | null;
  permissions?: string[];
  isAdmin?: boolean;
};

export const getInitials = (
  user: UserIdentity | null | undefined,
  profile: UserProfile | null
): string => {
  if (profile?.firstName && profile?.lastName) {
    return `${profile.firstName.charAt(0)}${profile.lastName.charAt(0)}`.toUpperCase();
  }

  return user?.username?.charAt(0).toUpperCase() || 'U';
};

export const getFullName = (
  user: UserIdentity | null | undefined,
  profile: UserProfile | null
): string => {
  if (profile?.firstName && profile?.lastName) {
    return `${profile.firstName} ${profile.lastName}`;
  }

  return user?.username || 'User';
};

export const getRoleText = (user: UserIdentity | null | undefined): string => {
  if (!user) return 'USER';
  if (user.isAdmin) return 'ADMIN';
  if (user.permissions?.length) return user.permissions.join(', ');
  return 'USER';
};
